import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeEvery, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { listPayload as listClubMembershipPayload } from 'redux/clubMemberships/sagas';
import { listPayload as listProductPayload } from 'redux/products/sagas';

import { getPersonalizationBlock } from './api';
import {
  GET_PERSONALIZATION_CONTENT_REQUEST,
  GET_PERSONALIZATION_CONTENT_SUCCESS,
  PERSONALIZATION_CONTENT_REQUESTING,
  RESET_PERSONALIZATION_CONTENT_ISFETCHING
} from './constants';

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PERSONALIZATION_CONTENT_REQUESTING });
    const response = yield call(
      getPersonalizationBlock,
      action.code,
      cartId(),
      customerId()
    );
    yield put({
      type: GET_PERSONALIZATION_CONTENT_SUCCESS,
      payload: response.data
    });
    if (response.data.type === 'Product Collection') {
      yield call(listProductPayload, response.data.products);
    }
    if (response.data.type === 'Club Shipment') {
      yield call(listClubMembershipPayload, response.data.clubMemberships);
    }
  } catch (error) {
    yield put({ type: RESET_PERSONALIZATION_CONTENT_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  // Need take every so that gets multiple collections on a page
  yield takeEvery(GET_PERSONALIZATION_CONTENT_REQUEST, get);
}

export default function* personalizationBlockSagas() {
  yield all([watchList()]);
}

const customerId = () => {
  if (!Cookies.get('customerToken')) {
    return null;
  }
  return jwtDecode(Cookies.get('customerToken')).sub;
};
const cartId = () => Cookies.get('cartId');
